import React from "react";
import { ArrowRight, Download, Link2 } from "react-feather";

const TargetIcon = ({ target }) => {
  if (!!target && !!target.url && target.type === "asset") {
    return <Download size={16} strokeWidth={1.5} />;
  }

  if (!!target && !!target.url && target.type === "url") {
    return <Link2 size={16} strokeWidth={1.5} />;
  }

  if (!!target && !!target.url && target.type === "entry") {
    return <ArrowRight size={16} strokeWidth={1.5} />;
  }

  return null;
};

export default TargetIcon;
